<template>
  <div>
    <el-row
      style="
        text-align: center;
        font-size: 16px;
        color: #303133;
        line-height: 18px;
        cursor: pointer;
        padding-top: 10px;
      "
    >
      <span @click="ShowDetail"
        >チャートパネル
        <i v-if="allBarShowFlg" class="el-icon-arrow-up"></i>
        <i v-else class="el-icon-arrow-down"></i>
      </span>
    </el-row>
    <el-row>
      <div
        v-if="$root.barscrollFlg === 'true' && allBarShowFlg"
        style="
          width: 100%;
          height: 200px;
          float: left;
          overflow-y: auto;
          overflow-x: hidden;
        "
      >
        <draggable
          v-model="$root.usedChartPresenceList"
          :options="{ disabled: !$root.editMode, animation: 300 }"
        >
          <component
            v-for="(chart, index) in $root.usedChartPresenceList"
            :is="chart.name"
            :title="chart.name"
            :displayTitle="chart.displayName"
            :key="index"
            :key1="index"
          ></component>
        </draggable>
      </div>
      <div
        v-else-if="$root.barscrollFlg === 'true' && !allBarShowFlg"
        style="width: 100%; float: left; overflow-y: auto; overflow-x: hidden"
      >
        <draggable
          v-model="$root.usedChartPresenceList"
          :options="{ disabled: !$root.editMode, animation: 300 }"
        >
          <component
            v-for="(chart, index) in $root.usedChartPresenceList"
            :is="chart.name"
            :title="chart.name"
            :displayTitle="chart.displayName"
            :key="index"
            :key1="index"
          ></component>
        </draggable>
      </div>
      <div v-else style="width: 100%; height: 28vh; float: left">
        <draggable
          v-model="$root.usedChartPresenceList"
          :options="{ disabled: !$root.editMode, animation: 300 }"
        >
          <component
            v-for="(chart, index) in $root.usedChartPresenceList"
            :is="chart.name"
            :title="chart.name"
            :displayTitle="chart.displayName"
            :key="index"
            :key1="index"
          ></component>
        </draggable>
      </div>

      <el-dialog
        :title="$root.currentPopUpTitle"
        :visible.sync="$root.popUpDisplay"
        class="historyDailog"
      >
        <hr />
        <echarts
          :auto-resize="true"
          :option="$root.currentChartData"
          style="height: 75vh"
        />
      </el-dialog>
    </el-row>
    <el-row
      style="
        text-align: center;
        font-size: 16px;
        color: #303133;
        line-height: 18px;
        cursor: pointer;
        padding: 5px 0 5px 0;
      "
    >
      <span @click="ShowTableDetail"
        >すべてのエージェント
        <i v-if="presenceTableShowFlg" class="el-icon-arrow-up"></i>
        <i v-else class="el-icon-arrow-down"></i>
      </span>
    </el-row>
    <el-row v-show="presenceTableShowFlg">
      <PresenceDetailTable></PresenceDetailTable>
    </el-row>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import PresenceDetailTable from "@/components/charts/PresenceDetailTable.vue";

export default {
  name: "RealTimePresenceMain",
  data() {
    return {
      allBarShowFlg: true,
      presenceTableShowFlg: true,
    };
  },
  components: {
    draggable,
    PresenceDetailTable,
  },
  methods: {
    ShowDetail() {
      if (this.allBarShowFlg == true) {
        this.allBarShowFlg = false;
      } else {
        this.allBarShowFlg = true;
      }
    },
    ShowTableDetail() {
      if (this.presenceTableShowFlg == true) {
        this.presenceTableShowFlg = false;
        this.$root.presenceTableHeight = '100%';
      } else {
        this.presenceTableShowFlg = true;
        this.$root.presenceTableHeight = '390';
      }
    },
  },
};
</script>
<style>
.echarts {
  width: inherit !important;
}
.no-search {
  margin-bottom: 27px;
}
.sub-view .sub-title {
  background-color: lightgrey;
  padding: 5px;
  margin-bottom: 0;
  font-weight: bold;
}

.sub-view .el-icon-close,
.sub-view .el-icon-zoom-in {
  float: right;
}

.el-icon-close:hover,
.el-icon-zoom-in:hover {
  cursor: pointer;
}

.el-alert {
  margin-top: 5px;
}

.el-dialog__body {
  padding: 10px 20px;
}

.el-dialog__title {
  font-weight: bold;
}

.el-dialog {
  margin-top: 10vh !important;
  /* width: 70%;
  min-height: 80%; */
}

.opacity {
  color: #646464;
  opacity: 0.5;
  width: 100%;
}
</style>
